import { useDispatch } from "react-redux";
import { CloseIcon } from "./icons";
import BestSellerBadge from "./BestSellerBadge";
import {
  ProductName,
  ProductBadges,
  ProductDetails,
  ProductPrice,
} from "./ProductsList";
import TotemSearchButton from "../containers/Selfcheckout/TotemSearchButton";
import { setSearchText } from "../ducks/productsSlice";

/**
 * Vitrine do totem: título do grupo (ou da busca) e os produtos em grade de
 * cartões, 2 colunas em pé e 3 deitado. Nome, selos, descrição e preço são os
 * mesmos componentes do cartão do celular (ProductsList), em escala maior.
 */
export default function ProductsListTotem({
  searchText,
  group,
  products,
  onProductSelect,
}) {
  const dispatch = useDispatch();
  const clearSearch = () => dispatch(setSearchText({ searchText: "" }));

  return (
    <div className="totem-products__content">
      <header className="totem-products__header">
        <div className="totem-products__heading">
          {searchText && <p className="totem-products__eyebrow">Busca</p>}
          <h1 className="totem-products__title">
            {searchText ? `“${searchText}”` : group.name}
          </h1>
        </div>
        <div className="totem-products__tools">
          {searchText && (
            <button
              type="button"
              className="totem-pill-button"
              onClick={clearSearch}
            >
              <CloseIcon /> Limpar
            </button>
          )}
          <TotemSearchButton />
        </div>
      </header>

      {!products || products.length === 0 ? (
        <div className="totem-empty">
          <p>Ops, nenhum produto encontrado...</p>
        </div>
      ) : (
        <ul className="totem-grid">
          {products.map((product) => (
            <li key={product.id} className="totem-grid__cell">
              <TotemProductCard
                product={product}
                onSelect={() => onProductSelect(product.id)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function TotemProductCard({ product, onSelect }) {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect();
    }
  };

  return (
    <div
      className={`totem-card${product.disabled ? " is-disabled" : ""}`}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
    >
      {product.pictureUrl && (
        <div className="totem-card__media">
          <img
            src={product.pictureUrl}
            alt=""
            loading="lazy"
            decoding="async"
            className="totem-card__img"
          />
          {product.isBestSeller && <BestSellerBadge overlay />}
        </div>
      )}
      <div className="totem-card__body">
        <ProductName product={product} />
        <ProductBadges product={product} />
        <ProductDetails product={product} />
        <ProductPrice product={product} />
      </div>
    </div>
  );
}
